// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"fe549d81","212":"4af02abf","396":"84f13bca","421":"25b1d5ea","655":"d3e4275c","996":"7a2232ce"}[chunkId] + ".chunk.css";
};